// extracted by extract-css-chunks-webpack-plugin
module.exports = {"containerText":"_1_SUiM","fullWidthText":"_2comue"};